import { MainLayout } from '@/components/layout/MainLayout';
import { WeatherStrip } from '@/components/schedule/WeatherStrip';
import { JobTimeline } from '@/components/schedule/JobTimeline';
import { useSearchParams, useParams } from 'react-router-dom';

export const CalendarPage = () => {
  const [searchParams] = useSearchParams();
  const { viewType, date } = useParams<{ viewType?: string; date?: string }>();

  // Parse URL parameters
  const preselectedJobId = searchParams.get('jobId');
  const preselectedClientId = searchParams.get('clientId');

  // Parse view type from URL (Day, Week, Month, Year, Gantt)
  const initialViewMode = viewType ?
    (viewType.charAt(0).toUpperCase() + viewType.slice(1).toLowerCase()) as 'Day' | 'Week' | 'Month' | 'Year' | 'Gantt'
    : undefined;

  // Parse date from URL (format: MM-DD-YY or MM-DD-YYYY)
  const initialDate = date ? (() => {
    try {
      const parts = date.split('-');
      if (parts.length === 3) {
        const [month, day, year] = parts;
        const fullYear = year.length === 2 ? `20${year}` : year;
        // Create date in local timezone to avoid UTC conversion issues
        return new Date(parseInt(fullYear), parseInt(month) - 1, parseInt(day));
      }
    } catch (e) {
      console.error('Invalid date format in URL:', date);
    }
    return undefined;
  })() : undefined;

  return (
    <MainLayout noPadding>
      <WeatherStrip />
      <JobTimeline
        preselectedJobId={preselectedJobId || undefined}
        preselectedClientId={preselectedClientId || undefined}
        initialViewMode={initialViewMode}
        initialDate={initialDate}
      />
    </MainLayout>
  );
};
